module.exports = __webpack_public_path__ + "static/media/textura.b1875182.svg";